import template from './infoBox.html';

export const infoBoxComponent = {
  name: 'infoBox',
  restrict: 'E',
  transclude: {
    title: '?infoBoxTitle',
    body: '?infoBoxBody',
  },
  template,
  controllerAs: 'vm',
  controller: function ($element, envService) {
    'ngInject';
    this.$onInit = function () {
      $element.addClass('info-box');
      this.custom = envService.custom;
    };
  },
  bindings: {
    colorBackground: '<',
  },
};
